import React, { useEffect, useRef } from 'react';
import { IMessage } from '../../domain/message.interface';
import { UserMessage } from '../messages/UserMessage';
import { AssistantMessage } from '../messages/AssistantMessage';
import { TypingIndicator } from './TypingIndicator';

interface MessageListProps {
  messages: IMessage[];
  isTyping: boolean;
  selectButtons: (labels: string[]) => void;
  setEnabledInput: (enabled: boolean) => void;
}

export const MessageList: React.FC<MessageListProps> = ({
  messages,
  isTyping,
  selectButtons,
  setEnabledInput,
}) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  return (
    <div className="flex-1 overflow-y-auto pb-20 pt-4 flex flex-col gap-4">
      {messages.map((msg, index) =>
        msg.userMessage ? (
          <UserMessage key={index} message={msg.content} />
        ) : (
          <AssistantMessage
            key={index}
            message={msg.content}
            buttons={msg.buttons}
            selectButtons={selectButtons}
            setEnabledInput={setEnabledInput}
          />
        )
      )}
      {isTyping && <TypingIndicator />}
      <div ref={bottomRef} />
    </div>
  );
};
